import React from 'react'
// components
import ApiTokensPageAPI from 'containers/ApiTokens/layers/API/index'
import ApiTokens from 'components/PageComponents/Settings/ApiTokens'
import TableManagementProvider from 'containers/Search/layers/BL'

const ApiTokensContainer: React.FC = () => {
  return (
    <TableManagementProvider>
      <ApiTokensPageAPI>
        <ApiTokens />
      </ApiTokensPageAPI>
    </TableManagementProvider>
  )
}

export default ApiTokensContainer
